<template>
  <ODialog ref="dialog" hideWhenLoading :maxWidth="450">
    <v-card v-if="row != null">
      <ODialogBar title="Referência de Valores" @close="dismiss" />
      <v-card-text class="pa-3 maxh-4">
        <div v-for="p in productTypes" :key="p.id" class="mb-6">
          <label class="light-caption">{{ p.alias }}</label>
          <ValuesTable :values="p.values" @itemClicked="apply" />
        </div>
      </v-card-text>
    </v-card>
  </ODialog>
</template>

<script>
import { CostCenter } from '@/models'
import ValuesTable from './ValuesTable.vue'

export default {
  components: { ValuesTable },
  data() {
    return { row: null, products: null }
  },
  computed: {
    productTypes() {
      if (this.row == null) return []

      return this.row.productTypes.map((p) => {
        return {
          id: p.id,
          alias: p.alias,
          values: [
            { name: 'Instalação', value: p.installValue },
            { name: 'Retirada', value: p.removeValue },
            { name: 'Mensalidade', value: p.monthlyValue }
          ]
        }
      })
    }
  },
  methods: {
    async open(costCenterId) {
      if (costCenterId == null) {
        let message =
          'Selecione um centro de custo para ver a sua referência de valores.'
        this.$info({ message })
      } else {
        this.row = null
        this.$refs.dialog.$loading(async () => {
          this.row = await CostCenter.findById(costCenterId)
          // this.products = await CostCenter.getProducts(costCenterId)
        })
        return this.$refs.dialog.$open()
      }
    },

    apply(x) {
      this.$refs.dialog.$apply(x.value)
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    }
  }
}
</script>

<style></style>
